<template>
	<div id='app'>
		<div id='container' style="padding: 30px 0px;">
			<ejs-schedule :height='height' :selectedDate='selectedDate' :views = 'views' :eventSettings='eventSettings'></ejs-schedule>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import {SchedulePlugin, Day, Week, TimelineViews, Month, Agenda } from '@syncfusion/ej2-vue-schedule';

let data = [{
	Id: 1,
	Subject: 'Paris',
	StartTime: new Date(2018, 1, 15, 10, 0),
	EndTime: new Date(2018, 1, 15, 12, 30)
}];

Vue.use(SchedulePlugin);
export default {
	data (){
		return {
			height: '550px',
			views: ['Day', 'Week', 'TimelineWeek', 'Month', 'Agenda'],
			eventSettings: {
				dataSource: data
			},
			selectedDate: new Date(2021, 11, 15),
		}
	},
	provide: {
		schedule: [Day, Week, TimelineViews, Month, Agenda]
	}
}

</script>

<style>
@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
</style>